<template>
  <div id="map-controls-sidebar-own-vessel">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeOwnVesselSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">自社船</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_OWN_VESSEL_SIDEBAR(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" color="#828282" />

        <div class="py-4 px-6">
          <template v-if="ownVessels.length === 0">
            <h5>登録されている自社船舶はありません</h5>
          </template>
        </div>

        <component
          :is="scrollbarTag"
          class="scroll-area--customizer pb-12"
          :settings="settings"
          :key="$vs.rtl"
        >
          <ul class="pb-20">
            <li
              class="pb-4 pl-4 pr-4"
              v-for="ownVessel in ownVessels"
              :key="ownVessel.id"
            >
              <own-vessel-card
                :ownVessel="ownVessel"
                @showDetails="showVesselDetail($event)"
                @jumpToMap="jumpToMap($event)"
                @onFetchWake="onFetchWake($event)"
                @onChangePosition="setOwnVesselPosition($event)"
                @createExpiredPopup="createExpiredPopup($event)"
              ></own-vessel-card>
            </li>
          </ul>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import OwnVesselCard from "./OwnVesselCard";

import { createNamespacedHelpers } from "vuex";
import moment from "moment-timezone";

const {
  mapActions: mapActionsOfLiveMap,
  mapState: mapStateOfLiveMap,
  mapGetters: mapGettersOfLiveMap,
  mapMutations: mapMutationsOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  components: {
    VuePerfectScrollbar,
    OwnVesselCard
  },
  props: {
    map: Object
  },
  data() {
    return {
      active: false,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      expiredPopup: null,
      timerId: null
    };
  },
  computed: {
    ...mapStateOfLiveMap({
      ownVessels: state => state.ownVessels,
      activeOwnVesselSidebar: state => state.activeOwnVesselSidebar
    }),
    ...mapGettersOfLiveMap(["hasWakes"]),
    rtl: {
      get() {
        return this.$vs.rtl;
      },
      set(val) {
        this.$vs.rtl = val;
      }
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_ACTIVE_OWN_VESSEL_SIDEBAR",
    ]),
    ...mapActionsOfLiveMap([
      "jumpToMap",
      "showVesselDetail",
      "fetchWake",
      "removeWake",
      "crateWakesLineFeature",
      "setOwnVesselPosition"
    ]),

    setActive(isActive) {
      this.active = isActive;
    },

    createExpiredPopup(emittedPopup) {
      if (this.expiredPopup !== null) {
        this.expiredPopup.remove();
        this.expiredPopup = null;
      }
      if (this.timerId) {
        clearTimeout(this.timerId);
        this.timerId = null;
      }
      this.expiredPopup = emittedPopup
      setTimeout(() => {
        this.expiredPopup.addTo(this.map);
        this.expiredPopup.addClassName("expired-vessel-live-position-popup");
      }, 100);
      this.timerId = setTimeout(() => {
        this.expiredPopup.remove();
        this.expiredPopup = null;
      }, 60000); // expiredPopupは1分経過で自動で消える
    },

    async onFetchWake(evt) {
      if (!this.hasWakes(evt.vesselId)) {
        const payload = {
          started_at:
            moment().utc()
              .subtract(1, "days")
              .format("YYYY-MM-DDTHH:mm:ss.000") + "Z",
          ended_at: moment().utc().format("YYYY-MM-DDTHH:mm:ss.000") + "Z",
          vesselId: evt.vesselId,
        }
        try {
          evt.cardComponent.isWakeLineLoading = true
          this.$vs.loading({
            color: "#2D9CDB",
            container: evt.cardComponent.$refs.wakeLineButton.$el,
            scale: 0.45
          })
          await this.fetchWake(payload);
          this.$vs.loading.close(evt.cardComponent.$refs.wakeLineButton.$el)
          evt.cardComponent.isWakeLineLoading = false
        } catch (e) {
          this.$vs.loading.close(evt.cardComponent.$refs.wakeLineButton.$el)
          evt.cardComponent.isWakeLineLoading = false
          this.$vs.notify({
            title: "航跡がありません",
            text: `「${ evt.name }」の航跡がないため表示できません`,
            color: "warning",
            position: "top-center"
          });
        }
      } else {
        await this.removeWake(evt.vesselId);
      }
    }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-own-vessel {
  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1;
  }

  #own-vessel-card {
    .vessel-img-area {
      position: relative;
    }

    .vessel-img-area p {
      position: absolute;
      top: 45%;
      left: 50%;
      color: $aisea-white;
      -ms-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      margin: 0;
      padding: 0;
    }

    img {
      width: 100%;
      object-fit: cover;
    }

    .vessel-ais-info-area {
      span {
        font-size: 13px;
      }
    }
  }
}
</style>
